import React from 'react';

import swoop from '../../images/belliercurve1920.png';
import graph1 from "../../images/line_graph_down.png";
import donuts from '../../images/donut_graph_combined.png'
import report from "./TiS_report.png";
import LandingHeader from "./LandingHeader";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import {styled} from "@mui/material/styles";
import {PieChart} from "@mui/x-charts";

const PREFIX = 'Landing';
const classes = {
   root: `${PREFIX}-root`,
   paper: `${PREFIX}-paper`,
   roundedBtn: `${PREFIX}-roundedBtn`,
   upsellContainer: `${PREFIX}-upSellContainer`,
   upsellHeader: `${PREFIX}-upSellHeader`,
   placeholderImage: `${PREFIX}-placeholderImage`,
   descriptionBlock: `${PREFIX}-descriptionBlock`,
   descriptionTextR: `${PREFIX}-descriptionTextR`,
   descriptionTextL: `${PREFIX}-descriptionTextL`,
   textField: `${PREFIX}-textField`,
   extraLongInput: `${PREFIX}-extraLongInput`,
   sectionHeader: `${PREFIX}-sectionHeader`,
   divider: `${PREFIX}-divider`,
   register: `${PREFIX}-register`
}

const Root = styled('div')(({ theme }) => ({
   [`&.${classes.root}`]: {
      '& .MuiInputBase-root': {
         background: 'white',
      },
   },
   [`& .${classes.paper}`]: {
      textAlign: 'center',
      color: theme.palette.text.secondary,
   },
   [`& .${classes.roundedBtn}`]: {
      margin: theme.spacing(1),
      borderRadius: "5em"
   },
   [`& .${classes.upsellContainer}`]: {
      backgroundColor: "#fafafa",
   },
   [`& .${classes.upsellHeader}`]: {
      backgroundColor: "#f5f5f5",
      paddingTop: "15px",
      paddingLeft: "15px",
      paddingRight: "15px",
   },
   [`& .${classes.placeholderImage}`]: {
      width: "350px",
      height: "300px",
      border: "2px solid #263238",
      borderRadius: "10px",
   },
   [`& .${classes.descriptionBlock}`]: {
      paddingTop: "15px",
      paddingBottom: "25px",
      borderBottom: "1px solid #eceff1",
   },
   [`& .${classes.descriptionTextL}`]: {
      paddingRight: "25px",
   },
   [`& .${classes.descriptionTextR}`]: {
      paddingLeft: "25px",
   }
}));

export default function LandingPage(props) {
  return (
     <Root className={classes.root}>
        <Paper className={classes.paper}>
           <Grid container className={classes.upsellContainer}>
              <LandingHeader></LandingHeader>
              <Grid size={12} className={classes.upsellHeader}>
                <Typography variant={"h2"} color={"primary"} align={"center"}>
                   We make budgeting easy.
                </Typography>
              </Grid>
              <Grid container className={"swoop"} sx={{width: "100%"}}>
                <img src={swoop} alt="swoop" width="100%"/>
              </Grid>
              <Container maxWidth={"md"}>
                 <Grid container className={"upsell"} direction={"row"} sx={{justifyContent: "center", alignItems: "center"}}>
                    <Grid size={12}><Typography variant={"h5"} color={"primary"}>Solutions for the modern family</Typography></Grid>
                 </Grid>

                 <Grid container className={classes.descriptionBlock} direction={"row"} justifyContent={"center"} alignItems={"center"}>
                    <Grid><img src={graph1} width={325} alt="Graph1"/></Grid>
                    <Grid>
                       <Typography className={classes.descriptionTextR} variant={"h4"}>Visualize spend</Typography>
                    </Grid>
                 </Grid>
                 <Grid container className={classes.descriptionBlock} direction={"row"} sx={{justifyContent: "center", alignItems: "center"}}>
                    <Grid>
                       <Typography className={classes.descriptionTextL} variant={"h4"}>Budget by category</Typography>
                    </Grid>
                    <Grid>
                       <PieChart
                          series={[
                             {
                                data: [
                                   { id: 0, value: 2500, label: 'Bills', color: '#546e7a' },
                                   { id: 2, value: 1500, label: 'Groceries', color: '#4db6ac' },
                                   { id: 1, value: 150, label: 'Entertainment', color: '#2c2c2c' },
                                   { id: 3, value: 500, label: 'Amazon', color: '#ffab00' },
                                ],
                                innerRadius: 40,
                             },
                          ]}
                          width={400}
                          height={200}
                       />
                    </Grid>
                 </Grid>
                 <Grid container className={classes.descriptionBlock} direction={"row"} sx={{justifyContent: "center", alignItems: "center"}}>
                    <Grid><img width={"300px"} src={report} alt="Reports"/></Grid>
                    <Grid>
                       <Typography className={classes.descriptionTextR} variant={"h4"}>Detailed History</Typography>
                    </Grid>
                 </Grid>
              </Container>
           </Grid>
        </Paper>
     </Root>
  );
}



